import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { GetAgentWhatsappNumberResponse } from '@dreamai/types';
import api from '../api';

/**
 * The agent's WhatsApp number (or null while loading / when unavailable),
 * plus a ready-made wa.me deep link for "chat on WhatsApp" actions.
 */
export const useAgentWhatsappNumber = (): {
  whatsappNumber: string | null;
  whatsappLink: string | null;
  agentWhatsappNumber: string | null;
  agentWhatsappLink: string | null;
} => {
  const { getAccessTokenSilently } = useAuth0();
  const [whatsappNumber, setWhatsappNumber] = useState<string | null>(null);
  const [agentWhatsappNumber, setAgentWhatsappNumber] = useState<string | null>(
    null,
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getAccessTokenSilently();
        const res = await api.get<GetAgentWhatsappNumberResponse>(
          '/agent-whatsapp/number',
          { headers: { Authorization: `Bearer ${token}` } },
        );
        if (!cancelled) {
          setWhatsappNumber(res.data.whatsapp_number);
          setAgentWhatsappNumber(res.data.agent_whatsapp_number ?? null);
        }
      } catch (err) {
        console.error('Failed to load agent WhatsApp number:', err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently]);

  // The deep link must target the ASSISTANT's business number (the number the
  // user chats to), not the user's own connected number.
  const whatsappLink =
    whatsappNumber && agentWhatsappNumber
      ? `https://wa.me/${agentWhatsappNumber.replace(/\D/g, '')}`
      : null;

  const agentWhatsappLink = agentWhatsappNumber
    ? `https://wa.me/${agentWhatsappNumber.replace(/\D/g, '')}`
    : null;

  return {
    whatsappNumber,
    whatsappLink,
    agentWhatsappNumber,
    agentWhatsappLink,
  };
};
